module.exports = __webpack_public_path__ + "opinion-8e89ac9112a8a9e1b821fe5fd38f9d5b.svg";